import { gql } from "@apollo/client";

export const ADD_OR_UPDATE_VEHICLE = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicle {
        id
        uuid
        description
        owner {
          id
        }
        plateType {
          id
          oriId
          name
          position
        }
        value
        vehicleColor {
          id
          oriId
          name
          position
        }
        vehicleMake {
          id
          oriId
          name
          position
        }
        vehicleModel {
          id
          oriId
          name
          position
        }
        vehiclePlate {
          id
          oriId
          name
          position
        }
        vehicleState {
          id
          oriId
          name
          position
        }
        vehicleVin {
          id
          oriId
          name
          position
        }
        year
        validVehicleAlerts {
          alertType {
            id
            name
            alertLevel
            oriId
            position
          }
          expireAt
          id
          notes
          officerId
          vehicle {
            id
          }
        }
      }
    }
  }
`